// import { ChangeDetectorRef, Component, Inject, Injectable } from "@angular/core";
import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, OnChanges, 
         DoCheck, Inject, OnDestroy  } from '@angular/core';
import {
     DwColumnFormatType, DwColumnRendererParams, DwDecoratorType, DwGridColumn, DwGridColumnDef, DwGridColumnRendererBase,
     getDefaultColumnStyle, DwEventService, DwGridColumnBaseComponent, DwMetaDataService, DwMetaDataServiceToken, DwLookupInfo,
     DwAction, DwGridActionConfig, DwGridActionKeys, DwActionType, DwActionButtonComponent, DwMetaDataConfigContext,
     DwActionPreference
} from "@devwareapps/devware-cap";
import { FleetMetaDataItemNames, AuctionEntity, CodeValueFleetAuctionStatus, FleetAuctionGridQueryQueryEntity } from "../meta-data/fleet-meta-data.service";
// import { BillingEntity, ProjectKickoffMetaDataItemNames } from "../meta-data/projectkickoff-meta-data.service";
// import { AppMetaDataLookups } from "../../../meta-data/app-meta-data.service";

@DwAction<DwGridActionConfig>({
   keyName: 'fleet-addbid-action',
   display: 'Add Auction Bid',
   actionType: DwActionType.gridRowAction,
   decoratorType: DwDecoratorType.component,
   configComponent: FleetAddBidComponent,
   isGlobal: false,
   parentItemName: [FleetMetaDataItemNames.Auction, FleetMetaDataItemNames.RoAuction],
   //allowOnce: true,
})
@Component({
    selector: 'fleet-addbid-button',
    template: `
    <span class="add-bid">
        <i class="fas fa-plus" (click)="addBid()" title="Add Bid"></i>
        <input type="text" class="form-control" style="margin-bottom:0px" [(ngModel)]='bidAmount' 
              (ngModelChange)="bidChanged($event)" [placeholder]="'$???'"/>
    </span>
`
})
export class FleetAddBidComponent implements DwActionButtonComponent<any, DwMetaDataConfigContext> {
    actionPreference: DwActionPreference<any>;
    bidAmount: number;
    ngOnInit(): void {
    }
  
    ngOnDestroy(): void {
    }
    
    setupComponent() {
    }
    bidChanged(e){
    }
    addBid() {
    }
    
}